var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const Quality = {
    Standard: { width: 1280, height: 720 },
    High: { width: 1920, height: 1080 },
};
export default class Recorder {
    constructor(app) {
        this.app = app;
        this.mediaRecorder = null;
        this.recordedChunks = [];
        this.stream = null;
        this.recStartTs = null;
    }
    startRecording(fps, quality, micReq, camReq) {
        return __awaiter(this, void 0, void 0, function* () {
            this.recStartTs = this.app.timestamp();
            const videoConstraints = quality;
            try {
                this.stream = yield navigator.mediaDevices.getUserMedia({
                    video: camReq ? Object.assign(Object.assign({}, videoConstraints), { frameRate: { ideal: fps } }) : false,
                    audio: micReq,
                });
                this.mediaRecorder = new MediaRecorder(this.stream, {
                    mimeType: 'video/webm;codecs=vp9',
                });
                this.recordedChunks = [];
                this.mediaRecorder.ondataavailable = (event) => {
                    if (event.data.size > 0) {
                        this.recordedChunks.push(event.data);
                    }
                };
                this.mediaRecorder.start();
            }
            catch (error) {
                console.error(error);
            }
        });
    }
    stopRecording() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => {
                if (!this.mediaRecorder)
                    return;
                this.mediaRecorder.onstop = () => {
                    const blob = new Blob(this.recordedChunks, {
                        type: 'video/webm',
                    });
                    resolve(blob);
                };
                this.mediaRecorder.stop();
            });
        });
    }
    sendToAPI() {
        return __awaiter(this, void 0, void 0, function* () {
            const blob = yield this.stopRecording();
            // const formData = new FormData()
            // formData.append('file', blob, 'record.webm')
            // formData.append('start', this.recStartTs?.toString() ?? '')
            return fetch(`${this.app.options.ingestPoint}/v1/web/uxt/upload-url`, {
                headers: {
                    Authorization: `Bearer ${this.app.session.getSessionToken()}`,
                },
            })
                .then((r) => {
                if (r.ok) {
                    return r.json();
                }
                else {
                    throw new Error('Failed to get upload url');
                }
            })
                .then(({ url }) => {
                return fetch(url, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'video/webm',
                    },
                    body: blob,
                });
            })
                .catch(console.error)
                .finally(() => {
                this.discard();
            });
        });
    }
    saveToFile(fileName = 'recorded-video.webm') {
        return __awaiter(this, void 0, void 0, function* () {
            const blob = yield this.stopRecording();
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        });
    }
    discard() {
        var _a, _b;
        (_a = this.mediaRecorder) === null || _a === void 0 ? void 0 : _a.stop();
        (_b = this.stream) === null || _b === void 0 ? void 0 : _b.getTracks().forEach((track) => track.stop());
    }
}
